export const userData = () => {
    let user = JSON.parse(localStorage.getItem('user'));

    return user;
}